<template>
  <div class="link-views no-bg" ref="box" id="link">
    <Row :gutter="16" type="flex" class="virtualLab">
      <i-col :xs="12" :sm="12" :md="12" :lg="12" :xxl="6">
        <div class="bg-div">
          <div class="img">
            <img src="../../../assets/imgs/item2.png">
          </div>
          <div class="imgInfo">
            <div class="small text-overflow">虚拟仿真实验总数</div>
            <div class="big theme">{{ExpSum}}</div>
          </div>
        </div>
      </i-col>
      <i-col :xs="12" :sm="12" :md="12" :lg="12" :xxl="6">
        <div class="bg-div">
          <div class="img">
            <img src="../../../assets/imgs/item5.png">
          </div>
          <div class="imgInfo">
            <div class="small text-overflow">虚拟实验完成总次数</div>
            <div class="big theme">{{CountSum}}</div>
          </div>
        </div>
      </i-col>
      <i-col :xs="12" :sm="12" :md="12" :lg="12" :xxl="6">
        <div class="bg-div">
          <div class="img">
            <img src="../../../assets/imgs/item6.png">
          </div>
          <div class="imgInfo">
            <div class="small text-overflow">虚拟实验使用总时长（min）</div>
            <div class="big theme">{{TimeSum}}</div>
          </div>
        </div>
      </i-col>
      <i-col :xs="12" :sm="12" :md="12" :lg="12" :xxl="6">
        <div class="bg-div">
          <div class="img">
            <img src="../../../assets/imgs/item7.png">
          </div>
          <div class="imgInfo">
            <div class="small text-overflow">虚拟平台总访问量</div>
            <div class="big theme">{{LoginSum}}</div>
          </div>
        </div>
      </i-col>
    </Row>
    <div class="select-div">
      <div class="mr">
        <span>时间选择：</span>
        <DatePicker
          v-model="daterange"
          format="yyyy-MM-dd"
          type="daterange"
          placement="bottom-start"
          placeholder="Select date"
          style="width: auto"
          clearable
          :editable="false"
          @on-change="getTime"
        ></DatePicker>
      </div>
      <div>
        <Button type="primary" class="mr" icon="md-search" @click="searchByTime('search')">查询</Button>
        <Button type="primary" class="mr" icon="md-refresh" @click="searchByTime('refresh')">重置</Button>
        <Button type="primary"  @click="downExp()">下载实验数据</Button>
      </div>
    </div>
    <Row :gutter="16" type="flex">
      <i-col :xs="24" :sm="24" :md="24" :lg="12" :xxl="12">
        <div class="result" id="result" ref="result">
          <div class="resultTitle">虚拟资源分布图(截止目前)</div>
          <div class="resultInfo">
            <ve-line
              :grid="{left:16,right:60}"
              :judge-width="true"
              :data="chartData1"
              :settings="chartSettings1"
              :extend="chartExtend1"
              :data-empty="dataEmpty1"
            ></ve-line>
          </div>
        </div>
      </i-col>
      <i-col :xs="24" :sm="24" :md="24" :lg="12" :xxl="12">
        <div class="result">
          <div class="resultTitle">虚拟实验操作前五占比（%）</div>
           <Row :gutter="16" type="flex" style="padding:0 16px;">
            <i-col :xs="24" :sm="24" :md="24" :lg="24" :xxl="12">
                <ve-ring
                :grid="{left:16,right:16}"
                :judge-width="true"
                :data="chartData2"
                :extend="chartExtend2"
                :settings="chartSettings2"
                :data-empty="dataEmpty2"
              ></ve-ring>
            </i-col>
            <i-col :xs="24" :sm="24" :md="24" :lg="24" :xxl="12">
              <ve-ring
                :grid="{left:16,right:16}"
                :judge-width="true"
                :data="chartData3"
                :extend="chartExtend3"
                :settings="chartSettings3"
                :data-empty="dataEmpty3"
              ></ve-ring>
            </i-col>
          </Row>

        </div>
      </i-col>
    </Row>
    <Row :gutter="16" type="flex">
      <i-col :xs="24" :sm="24" :md="24" :lg="12" :xxl="12">
        <div class="result" id="result" ref="result">
          <div class="resultTitle">时长排行（min）</div>
          <div class="">
            <ve-bar
              :grid="{left:16,right:16}"
              :judge-width="true"
              :data="chartData4"
              :extend="chartExtend4"
              :settings="chartSettings4"
              :data-empty="dataEmpty4"
              :height="height"
            ></ve-bar>
          </div>
        </div>
      </i-col>
      <i-col :xs="24" :sm="24" :md="24" :lg="12" :xxl="12">
        <div class="result">
          <div class="resultTitle">次数排行</div>
          <div class="resultInfo">
            <ve-bar
              :grid="{left:16,right:16}"
              :judge-width="true"
              :data="chartData5"
              :extend="chartExtend5"
              :settings="chartSettings5"
              :data-empty="dataEmpty5"
              :height="height"
            ></ve-bar>
          </div>
        </div>
      </i-col>
    </Row>
    <div class="bg-div">
      <div class="select-div">
        <div class="mr">
          <span>学院名称：</span>
          <i-select style="width:200px" v-model="FieldExpPageData.CollegeId">
             <i-option value='0'>全部</i-option>
            <i-option
              v-for="item in CollegeList"
              :value="item.CollegeId"
              :key="item.CollegeId"
            >{{ item.CollegeName }}</i-option>
          </i-select>
        </div>
        <div class="mr">
          <span>关键字：</span>
          <Input clearable v-model="FieldExpPageData.keyword" style="width:200px"/>
        </div>
        <div>
          <Button
            type="primary"
            class="mr"
            icon="md-search"
            @click="sureSearch(FieldExpPageData.CollegeId,FieldExpPageData.keyword)"
          >查询</Button>
          <Button type="primary" icon="md-refresh" @click="sureSearch('0','')">重置</Button>
        </div>
      </div>
      <div v-if="FieldExpObj.Result.length>0">
        <Row
          :gutter="16"
          class="hasImgDiv"
          type="flex"
          v-for="(item,index) in FieldExpObj.Result"
          :key="index"
        >
          <i-col :xs="24" :sm="24" :md="24" :lg="8" :xxl="6">
            <div class="flImg">
              <img v-if="item.ExpPicUrl" :src="port+item.ExpPicUrl" alt>
            </div>
          </i-col>
          <i-col :xs="24" :sm="24" :md="24" :lg="16" :xxl="18" class="flex-column">
            <div>
              <strong class="p10">{{item.ExpName}}</strong>
              <span class="small ml">实验ID：{{item.ExpID}}</span>
            </div>
            <div class="flexDiv flex1">
              <div>实验简介</div>
              <div class="flex1">
                <div>{{item.Abstract}}</div>
              </div>
            </div>
            <div class="btnBox">
              <router-link :to="{name:'shoolvirtual',params:{id:item.ExpID}}">
                <Button type="primary">查看详情</Button>
              </router-link>
              <a href="javascript:void(0)" @click="enterExpUrl(item.ExpID)">
                <Button type="primary">进入实验</Button>
              </a>
            </div>
          </i-col>
        </Row>
        <div class="page-div">
          <Page
            show-total
            :total="FieldExpObj.records"
            :current="FieldExpPageData.page"
            :page-size="FieldExpPageData.size"
            @on-change="changePage"
          />
        </div>
      </div>
      <div v-else class="nodata">暂无数据</div>
    </div>
  </div>
</template>

<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/teacher-api.js";
import * as publicApi from "../../../api/public-api.js";
import VeRing from "v-charts/lib/ring.common.js";
import VeBar from "v-charts/lib/bar.common.js";
export default {
  name: "schoolStatistics",
  components: {
    VeRing,
    VeBar
  },
  data() {
    this.chartExtend1 = {
      tooltip: {
        show: true,
        formatter: function(params) {
          return (
            params[0].axisValue +
            "拥有实验数量：<br/>" +
            params[0].data[1] +
            "个"
          );
        },
        confine: true
      },
      xAxis: {
        axisLabel: {
          interval: 0, //0：全部显示，1：间隔为1显示对应类目，2：依次类推，（简单试一下就明白了，这样说是不是有点抽象）
          rotate: -45 //倾斜显示，-：顺时针旋转，+或不写：逆时针旋转
        }
      }
    };
    this.chartSettings1 = {
      yAxisName: ["数量"],
      labelMap: {
        ExpCount: ""
      }
    };
    this.chartExtend2 = {
      title: {
        text: "次数"
      },
      legend: {
        orient: "vertical",
        y: "bottom"
      },
      tooltip: {
        trigger: "item",
        formatter: "{b}: <br/>{c}(次) ({d}%)",
        confine: true
      }
    };
    this.chartSettings2 = {
      name: "次数",
      radius: [60, 80],
      offsetY: 160,
      avoidLabelOverlap: false,
      label: {
        normal: {
          show: false,
          position: "center"
        },
        emphasis: {
          show: true,
          textStyle: {
            fontSize: "14"
          }
        }
      },
      labelLine: {
        normal: {
          show: false
        }
      }
    };
    this.chartExtend3 = {
      title: {
        text: "时长"
      },
      legend: {
        orient: "vertical",
        y: "bottom"
      },
      tooltip: {
        trigger: "item",
        formatter: "{b}: <br/>{c}(min) ({d}%)",
        confine: true
      }
    };
    this.chartSettings3 = {
      name: "时长",
      radius: [60, 80],
      offsetY: 160,
      avoidLabelOverlap: false,
      label: {
        normal: {
          show: false,
          position: "center"
        },
        emphasis: {
          show: true,
          textStyle: {
            fontSize: "14"
          }
        }
      },
      labelLine: {
        normal: {
          show: false
        }
      }
    };
    this.chartExtend4 = {
      tooltip: {
        show: true,
        formatter: function(params) {
          return (
            params[0].axisValue +
            "<br/>" +
            params[0].seriesName +
            "：" +
            params[0].data +
            "min" +
            "<br/>" +
            params[1].seriesName +
            "：" +
            params[1].data +
            "min" +
            "<br/>" +
            params[2].seriesName +
            "：" +
            params[2].data +
            "min" +
            "<br/>" +
            params[3].seriesName +
            "：" +
            params[3].data +
            "min"
          );
        },
        confine: true
      }
    };
    this.chartSettings4 = {
      stack: {
        xxx: ["StuTimes", "TchTimes", "YchTimes", "AllTimes"]
      },
      labelMap: {
        StuTimes: "学生",
        TchTimes: "教师",
        YchTimes: "游客",
        AllTimes: "总数"
      }
    };
    this.chartExtend5 = {
      tooltip: {
        show: true,
        formatter: function(params) {
          return (
            params[0].axisValue +
            "<br/>" +
            params[0].seriesName +
            "：" +
            params[0].data +
            "次" +
            "<br/>" +
            params[1].seriesName +
            "：" +
            params[1].data +
            "次" +
            "<br/>" +
            params[2].seriesName +
            "：" +
            params[2].data +
            "次" +
            "<br/>" +
            params[3].seriesName +
            "：" +
            params[3].data +
            "次"
          );
        },
        confine: true
      }
    };
    this.chartSettings5 = {
      stack: {
        xxx: ["StuCounts", "TchCounts", "YchCounts", "AllCounts"]
      },
      labelMap: {
        StuCounts: "学生",
        TchCounts: "教师",
        YchCounts: "游客",
        AllCounts: "总数"
      }
    };
    return {
      port: homeConst.baseUrl + "/", //baseurl
      ExpSum: 0, //实验总数
      CountSum: 0, //完成总次数
      TimeSum: 0, //使用总时长
      LoginSum: 0, //平台访问量
      chartData1: {},
      dataEmpty1: true,
      chartData2: {},
      dataEmpty2: true,
      chartData3: {},
      dataEmpty3: true,
      chartData4: {},
      dataEmpty4: true,
      chartData5: {},
      dataEmpty5: true,
      daterange: "",
      pageData: {
        StartTime: "",
        EndTime: ""
      },
      CollegeList: [],
      FieldExpObj: {
        Result: []
      },
      FieldExpPageData: {
        CollegeId: '0',
        keyword: "",
        page: 1,
        size: 5
      },
      height: "400px"
    };
  },
  mounted() {
    this.getDaterange(); //获取当前时间
    this.getInfoData(this.pageData); //根据时间获取当前页面数据
    this.getDataList(); //获取所有学院
    this.GetFieldExp(); //获取所有实验
  },
  watch: {
    // CollegeId(val) {
    //   this.FieldExpPageData.CollegeId = val;
    //   this.FieldExpPageData.page = 1;
    //   this.GetFieldExp();
    // }
  },
  methods: {
    //获取当前时间
    getDaterange() {
      var day = new Date();
      day.setDate(day.getDate() - 7);
      var s1 = day.format("yyyy-MM-dd");
      this.pageData.StartTime = s1;
      this.pageData.EndTime = new Date().format("yyyy-MM-dd");
      this.daterange = [this.pageData.StartTime, this.pageData.EndTime];
    },
    // 首页
    getInfoData(pageData) {
      homeApi.GetFieldCount(pageData).then(res => {
        this.CountSum = res.TJ.CountSum;
        this.ExpSum = res.TJ.ExpSum;
        this.LoginSum = res.TJ.LoginSum;
        this.TimeSum = res.TJ.TimeSum;
        if (res.ExpRes.length > 0) {
          this.chartData1 = {
            columns: ["CollegeName", "ExpCount"],
            rows: res.ExpRes
          };
          this.dataEmpty1 = false;
        } else {
          this.chartData1 = {};
          this.dataEmpty1 = true;
        }
        // 次数
        if (res.ExpTopC.length > 0) {
          this.chartData2 = {
            columns: ["ExpName", "Count"],
            rows: res.ExpTopC
          };
          this.dataEmpty2 = false;
        } else {
          this.chartData2 = {};
          this.dataEmpty2 = true;
        }
        // 时长
        if (res.ExpTopT.length > 0) {
          this.chartData3 = {
            columns: ["ExpName", "TimeLength"],
            rows: res.ExpTopT
          };
          this.dataEmpty3 = false;
        } else {
          this.chartData3 = {};
          this.dataEmpty3 = true;
        }

        // 时长排行（min）
        if (res.ExpTimes.length > 0) {
          this.chartData4 = {
            columns: [
              "CollegeName",
              "StuTimes",
              "TchTimes",
              "YchTimes",
              "AllTimes"
            ],
            rows: res.ExpTimes.reverse()
          };
          this.dataEmpty4 = false;
        } else {
          this.chartData4 = {};
          this.dataEmpty4 = true;
        }
        // 次数排行
        if (res.ExpCount.length > 0) {
          this.chartData5 = {
            columns: [
              "CollegeName",
              "StuCounts",
              "TchCounts",
              "YchCounts",
              "AllCounts"
            ],
            rows: res.ExpCount.reverse()
          };
          this.dataEmpty5 = false;
        } else {
          this.chartData5 = {};
          this.dataEmpty5 = true;
        }
      });
    },
    // 时间处理
    getTime(value) {
      if (value.length > 0) {
        this.pageData["StartTime"] = value[0];
        this.pageData["EndTime"] = value[1];
      }
    },
    // 根据时间段获取数据
    searchByTime(type) {
      if (type == "refresh") {
        this.getDaterange();
      } else {
        this.pageData["StartTime"] = this.pageData["StartTime"]
          ? this.pageData["StartTime"]
          : "";
        this.pageData["EndTime"] = this.pageData["EndTime"]
          ? this.pageData["EndTime"]
          : "";
      }
      this.getInfoData(this.pageData);
    },
    downExp(){
      var that=this;
        homeApi.GetExcel({
          StartTime:this.pageData["StartTime"],
          EndTime:this.pageData["EndTime"]
        })
        .then(res => {
          // if(res.success==true){
           var a = document.createElement('a')
                a.href=that.port+res.file_path;
                a.download  ="实验数据.xls";
                a.click()
          // }
           
        })
    },
    // 获取所有学院
    async getDataList() {
      this.CollegeList = await homeApi.GetCollegeList();
      this.height =
        50 * this.CollegeList.length > 400
          ? 50 * this.CollegeList.length + "px"
          : "400px";
    },
    //获取所有实验列表
    async GetFieldExp() {
      this.FieldExpObj = await homeApi.GetFieldExp({
        CollegeId: this.FieldExpPageData.CollegeId
          ? this.FieldExpPageData.CollegeId
          : 0,
        keyword: this.FieldExpPageData.keyword
          ?this.FieldExpPageData.keyword
          : "",
        page: this.FieldExpPageData.page ? this.FieldExpPageData.page : 1,
        size: this.FieldExpPageData.size ? this.FieldExpPageData.size : 5
      });
    },
    //进入实验链接
    enterExpUrl(ExpID) {
      var newWindow = window.open();
      publicApi.GetExpUrl({ ExpID: ExpID }).then(res => {
        var enterExpUrlHref;
        if (res.ExpUrl) {
          if (res.ExpUrl.indexOf("http") == -1) {
            enterExpUrlHref = this.port + res.ExpUrl + "?token=" + res.ExpToken;
          } else {
            enterExpUrlHref = res.ExpUrl + "?token=" + res.ExpToken;
          }
        }
        newWindow.location.href = enterExpUrlHref;
      });
    },
    // 分页
    changePage(page) {
      this.FieldExpPageData.page = page;
      this.GetFieldExp();
    },
    // 搜索
    sureSearch(CollegeId, keyword) {
        this.FieldExpPageData.page =1;
      this.FieldExpPageData.CollegeId = CollegeId;
      this.FieldExpPageData.keyword = keyword;
      this.GetFieldExp();
    }
  }
};
</script>



<style scoped>
.resultInfo{
display: inline-block;
}

</style>